import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { Col, Card, Row, Button, Container } from "react-bootstrap";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { IMembershipBenefitsProps } from "./MembershipBenefitsProps";
import {
  Title,
  SubTitle,
  Description,
  LinksContainer,
} from "./MembershipBenefitsHelpers";

const benefitsCountIncrement = 4;
const HR = "/joinhellorewards";

const MembershipBenefits: React.FC<IMembershipBenefitsProps> = (props) => {
  const winSize = useWindowSize();
  const node = props.node;
  const isHRAndLoggedIn =
    node.field_link.url && node.field_link.url?.toLowerCase() === HR;
  const benefits = node?.relationships.field_benefits || null;
  const totalBenefits = benefits ? benefits.length : 0;

  const [benefitsShowCount, setBenefitsShowCount] = useState(0);

  const handleShowMore = () => {
    const updatedShowCount = benefitsShowCount + benefitsCountIncrement;
    setBenefitsShowCount(updatedShowCount);
  };

  const benefitsColumns = benefits
    .slice(0, benefitsShowCount)
    .map((benefit) => {
      const image = benefit.relationships.media.relationships.image.gatsbyImage;
      return (
        <Col lg={4} key={benefit.id} className="mb-4 text-center">
          <Card className="h-100 border-0">
            <Card.Img src={image.src} alt={benefit.field_title} variant="top" />
            <Card.Body>
              <h3 className="mb-3">{benefit.field_title}</h3>
              <Card.Text
                className="description"
                dangerouslySetInnerHTML={{ __html: benefit.field_description }}
              />
            </Card.Body>
          </Card>
        </Col>
      );
    });

  useEffect(() => {
    if (winSize.width > 991) {
      setBenefitsShowCount(totalBenefits);
    } else {
      // in mobile view limit number to benefits to be shown
      setBenefitsShowCount(
        totalBenefits > benefitsCountIncrement
          ? benefitsCountIncrement
          : totalBenefits
      );
    }
  }, [winSize]);

  return (
    <Container fluid className="bg-light pt-5 pb-4 pb-lg-5 mb-4 mb-lg-5">
      <Container fluid="sm">
        <Row className="justify-content-md-center">
          <Col className="text-center" lg={{ span: 8 }}>
            {node.field_subtitle !== null && (
              <SubTitle>{node.field_subtitle}</SubTitle>
            )}
            <Title>{node.field_title}</Title>
            <Description>{node.field_description}</Description>
            <LinksContainer className="text-center text-uppercase d-none d-lg-block">
              <Link
                to={isHRAndLoggedIn ? "/account" : node.field_link.url}
                className="btn btn-primary pl-5 pr-5"
              >
                {isHRAndLoggedIn ? "View Account" : node.field_link.title}
              </Link>
            </LinksContainer>
          </Col>
        </Row>
        {benefits && (
          <>
            <Row className="mt-lg-5 mt-3">{benefitsColumns}</Row>
            <Row className="mt-2 mb-4 d-lg-none">
              <Col className="text-center">
                <Link
                  to={node.field_link.url}
                  className="btn btn-primary pl-5 pr-5 w-100 text-uppercase"
                >
                  {node.field_link.title}
                </Link>
              </Col>
            </Row>
            {benefitsShowCount < totalBenefits && (
              <Row className="mb-2 d-lg-none">
                <Col className=" text-center">
                  <Button variant="link" onClick={handleShowMore}>
                    Show More Benefits +
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}
      </Container>
    </Container>
  );
};

export default MembershipBenefits;
